import { FC } from 'react';

import { Col, FormFeedback, FormGroup, Label } from 'reactstrap';

import classNames from 'classnames';
import { get } from 'radash';

import { BoximusPrime } from '@hsp/react-component-library';

import { s } from 'utilities/strings';

import { useOrderConfiguration } from './hooks';

const Order: FC = () => {
  const { errors, props, readOnly, ref } = useOrderConfiguration();

  return (
    <FormGroup row>
      <Label sm={4}>{s('Site.Order')}</Label>
      <Col sm={8}>
        <BoximusPrime
          {...props}
          className={classNames({
            'is-invalid': get(errors, 'orderNumber.type') === 'too_small',
          })}
          placeholder={s(readOnly ? ['Site.Select', 'Site.Audience'] : ['Site.Enter', 'Site.Order'])}
          plaintext={readOnly}
          readOnly={readOnly}
          ref={ref}
          type="text"
        />
        <FormFeedback type="invalid">{get(errors, 'orderNumber.message')}</FormFeedback>
      </Col>
    </FormGroup>
  );
};

export default Order;
